import AuthenticatedLayout from "@shared/layouts/AuthenticatedLayout";
import { TaskList } from "../components/TaskList";
import { useTasks } from "../hooks/useTasks";
import { TaskStatus } from "../types/task.types";

export default function TasksPage() {
  const {
    tasks,
    loading,
    createTask: createTaskService,
    updateTask: updateTaskService,
    deleteTask,
    toggleTaskStatus,
    addSubtask,
    toggleSubtask,
    updateSubtask,
    deleteSubtask,
    reorderSubtask,
    setTasks,
    updatePositions,
  } = useTasks();

  // Wrapper functions to handle void return type
  const createTask = async (data: {
    title: string;
    description?: string;
    dueDate?: Date;
  }) => {
    await createTaskService(data);
  };

  const updateTask = async (
    taskId: string,
    data: { title: string; description?: string; dueDate?: Date }
  ) => {
    await updateTaskService(taskId, data);
  };

  const handleToggleStatus = async (
    taskId: string,
    currentStatus: TaskStatus
  ) => {
    await toggleTaskStatus(taskId, currentStatus);
  };

  const handleAddSubtask = async (taskId: string, title: string) => {
    await addSubtask(taskId, title);
  };

  const handleToggleSubtask = async (taskId: string, subtaskId: string) => {
    await toggleSubtask(taskId, subtaskId);
  };

  const handleUpdateSubtask = async (
    taskId: string,
    subtaskId: string,
    title: string
  ) => {
    await updateSubtask(taskId, subtaskId, title);
  };

  const handleDeleteSubtask = async (taskId: string, subtaskId: string) => {
    await deleteSubtask(taskId, subtaskId);
  };

  const handleReorderSubtask = async (
    taskId: string,
    action: ['move-up' | 'move-down', string]
  ) => {
    await reorderSubtask(taskId, action);
  };

  return (
    <AuthenticatedLayout>
      <div className="flex h-screen overflow-hidden">
        <div className="relative flex flex-col flex-1 overflow-y-auto overflow-x-hidden">
          <main>
            <TaskList
              tasks={tasks}
              loading={loading}
              onCreateTask={createTask}
              onUpdateTask={updateTask}
              onDeleteTask={deleteTask}
              onToggleStatus={handleToggleStatus}
              onAddSubtask={handleAddSubtask}
              onToggleSubtask={handleToggleSubtask}
              onUpdateSubtask={handleUpdateSubtask}
              onDeleteSubtask={handleDeleteSubtask}
              onReorderSubtask={handleReorderSubtask}
              setTasks={setTasks}
              updatePositions={updatePositions}
            />
          </main>
        </div>
      </div>
    </AuthenticatedLayout>
  );
}
